import ReactApexChart from 'react-apexcharts';
import "./ChartStyle.scss"
export default function AreaChartItem({data}){
  const values = data.map(obj=>
    obj.value);
    const years = data.map(obj=>
      obj.year);
      const colors = ["#8CAE68", "#FF6347","#B3679B","#FFBA49","#175676","#90A9B7","#3F292B"]
      const random = Math.floor(Math.random() * colors.length);
  const series= [{
    name: 'series1',
    data: values
  }]
  const options= {
    chart: {
      type: 'area',
      toolbar: {
        show:false,
        offsetX: 20,
        tools: {
          download: false,
          selection: false,
          zoom: false,
          
          pan: false,
          reset: false,
        }
      }
    },grid: {
      borderColor: "#FFF",
      clipMarkers: false,
      yaxis: {
        lines: {
          show: false
        }
      }
    },
    dataLabels: {
      enabled: false
    },
    
    fill: {
      gradient: {
        enabled: true,
        opacityFrom: 0.55,
        opacityTo: 0
      }
    },
    colors: [`${colors[random]}`],
    legend: {
      show: false
    },
    stroke: {
      width: 2,
      curve: 'straight',
    },
    markers: {
      size: 4,
      hover: {
        size: undefined,
        sizeOffset: 3
      }
  },
    xaxis: {
      type: 'text',
      categories: years,
      tickAmount: 10
    }
  }

  return(
    <div id="chart">
      <ReactApexChart options={options} series={series} height="100%" type="area" />
    </div>
  );
}